import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Paper,
  Zoom,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import PreviewIcon from "@mui/icons-material/Preview";
import { makeStyles } from "@mui/styles";
import Controls from "./controls/Controls";

const useStyles = makeStyles({
  typography: {
    "&.MuiTypography-root": {
      fontFamily: "Rajdhani",
      fontWeight: 600,
      fontSize: "2.4rem",
      color: "#AAAAAA",
      lineHeight: "3rem",
    },
  },
  title: {
    "&.MuiTypography-root": {
      fontWeight: 700,
      fontSize: "3rem",
      color: "#FFFFFF",
      wordSpacing: "1.5rem",
    },
  },
  usingTech: {
    "&.MuiTypography-root": {
      fontWeight: 400,
      fontSize: "1.5rem",
    },
  },
  cardRoot: (item) => ({
    "&.MuiCard-root": {
      padding: "2.5rem",
      backgroundColor: "transparent",
      border: `3rem solid transparent`,
      transition: "ease-in-out 0.3s",

      "&:hover": {
        borderColor: item.borderColor,
      },
    },
  }),
  aboutProject: {
    "&.MuiPaper-root": {
      margin: "5rem 0rem",
      backgroundColor: "rgb(42, 42, 42)",
      padding: "3rem",
      minHeight: "fit-content",
      width: "125%",
      color: "rgb(171, 171, 171)",
      zIndex: "1",
    },
  },
});

function ProjectCard(props) {
  const { item } = props;
  const classes = useStyles(item);

  return (
    <>
      <Card
        elevation={5}
        className={classes.cardRoot}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <CardContent
            sx={{
              flex: "1 0 auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Typography
              className={`${classes.typography} ${classes.title}`}
              component="div"
              variant="h5"
            >
              {item.heading}
            </Typography>
            <Paper elevation={24} className={classes.aboutProject}>
              <Typography
                className={classes.typography}
                variant="body2"
                color="text.secondary"
                component="div"
              >
                {item.subTitle}
              </Typography>
            </Paper>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {item.usingTechnology.split(",").map((itemText) => (
                <Typography
                  className={`${classes.typography} ${classes.usingTech}`}
                  key={itemText}
                  component="span"
                  variant="h6"
                >
                  {itemText.toUpperCase()} &#160; &#160; &#160;
                </Typography>
              ))}
            </Box>
            <Box mt={2} sx={{ display: "flex", flexWrap: "wrap" }}>
              <Controls.Tooltip
                title="Code on Github"
                arrow
                TransitionComponent={Zoom}
              >
                <Controls.IconButton
                  href={item.githubLink}
                  color={item.borderColor}
                  sx={{ marginRight: "3rem" }}
                >
                  <GitHubIcon />
                </Controls.IconButton>
              </Controls.Tooltip>
              <Controls.Tooltip
                title="External Link & Live Preview"
                arrow
                TransitionComponent={Zoom}
              >
                <Controls.IconButton
                  href={item.liveDemo}
                  color={item.borderColor}
                  // title="Live"
                >
                  <PreviewIcon />
                </Controls.IconButton>
              </Controls.Tooltip>
            </Box>
          </CardContent>
        </Box>
        <CardMedia
          className={classes.cardMedia}
          component="img"
          sx={{ minWidth: "50%", maxHeight: "50rem" }}
          image={item.image}
          alt={item.heading}
        />
      </Card>
    </>
  );
}

export default ProjectCard;
